import { BUNDLE, FLOW } from './bundleConversionUtils'

const servicesOffered = ['FIOSSPEED', 'FTV', 'BVOICE', 'VOICE', 'BDV', 'HSI'];

const tvServicesOffered = ['LOCAL', 'CURRENT', 'PREFERRED', 'EXTREME', 'CUSTOM'];

export const getBundleType = (bannerId1) => {
    const splitChar = ' ';
    let bannerList = bannerId1?.split(splitChar);
    const applicableSrvc = servicesOffered.filter(e => bannerList?.indexOf(e) !== -1);
    return applicableSrvc;
}

export const getapplicableBundle = (bannerId1) => {
    let bundleFlowType = '';
    let flow = '';
    bannerId1 = bannerId1?.replaceAll("~", " ");
    let bannerList = getBundleType(bannerId1);
    if (bannerList?.length === 1) {
        bundleFlowType = bannerList[0] === 'FIOSSPEED' ? BUNDLE.DATA :
            (bannerList[0] === 'BVOICE' || bannerList[0] === 'BDV') ? BUNDLE.BDV :
                (bannerList[0] === 'VOICE') ? BUNDLE.PHONE : (bannerList[0] === 'HSI') ? BUNDLE.HSI :
                    (bannerList[0] === 'FTV') ? BUNDLE.VIDEO : '';
        // DEFINE FLOW
        flow = FLOW.STANDALONE;
    } else if (bannerList?.length === 2) {
        bundleFlowType = (bannerList?.indexOf('FIOSSPEED') !== -1 && bannerList?.indexOf('BDV') !== -1) ? BUNDLE.DATA_BDV :
            (bannerList?.indexOf('FIOSSPEED') !== -1 && bannerList?.indexOf('VOICE') !== -1) ? BUNDLE.DATA_PHONE :
                (bannerList?.indexOf('HSI') !== -1 && bannerList?.indexOf('VOICE') !== -1) ? BUNDLE.HSI_PHONE :
                    (bannerList?.indexOf('FTV') !== -1 && bannerList?.indexOf('FIOSSPEED') !== -1) ? BUNDLE.FLEX : '';
        // DEFINE FLOW
        flow = FLOW.DOUBLE;
    } else if (bannerList?.length === 3) {
        bundleFlowType = (bannerList?.indexOf('FIOSSPEED') !== -1 && bannerList?.indexOf('BDV') !== -1 && bannerList?.indexOf('FTV') !== -1) ? BUNDLE.BDV_DATA_VIDEO :
            (bannerList?.indexOf('FIOSSPEED') !== -1 && bannerList?.indexOf('VOICE') !== -1 && bannerList?.indexOf('FTV') !== -1) ? BUNDLE.PHONE_DATA_VIDEO : '';
        flow = FLOW.TRIPLE;
    }
    return { bundleFlowType, flow };
}

export const getBannerInternetSelectedPlan = (response, bannerStr) => {
    const splitChar = ' ';
    bannerStr = bannerStr.replaceAll("~", " ");
    let bannerData = bannerStr?.split(splitChar);
    let plan = '';
    if (bannerData?.indexOf('FIOSSPEED') !== -1) {
        plan = 'FIOSSPEED';
    } else if (bannerData?.indexOf('HSI') !== -1) {
        plan = "HSI";
    }
    const planIndex = bannerData?.indexOf(plan);
    let downloadSpeed = bannerData[planIndex + 1].slice(1);
    downloadSpeed = downloadSpeed === '1000' ? 'Gigabit' : downloadSpeed;
    const contract = 'TwoYears';
    const ip = 'Dynamic';

    const selectedPlan = response?.Plans?.filter(obj => {
        return obj.ProductName.includes(downloadSpeed) &&
            obj.IPType === ip && obj.Contract === contract
    });
    return selectedPlan && selectedPlan?.length !== 0 ? selectedPlan[0] : '';
}

export const getBDVValues = (input) => {
    let { selectedContract } = 'Two Years';
    const selectedContractAgreement = selectedContract === "No annual contract" ? "MonthToMonth" : "TwoYears";

    let prepareObj = {};
    if (input && ((input.BDVInfo) || (input.PhoneInfo))) {
        if (input.BDVInfo?.Plans?.length) {
            prepareObj.businessVoice = input.BDVInfo.Plans.filter(plan => {
                return (plan.Contract === selectedContractAgreement)
            })[0]
        }
        if (input.PhoneInfo?.Plans?.length) {
            prepareObj.standardVoice = input.PhoneInfo.Plans[0];
        }
    } else {
        prepareObj = null;
    }
    return prepareObj;
}

export const getBannerTVSelectedPlan = (response, bannerStr) => {
    const splitChar = ' ';
    let bannerData = bannerStr?.split(splitChar);
    let plan = 'FTV';
    const planIndex = bannerData?.indexOf(plan);
    const planType = bannerData[planIndex + 2]?.toLowerCase();

    let selectedPlan = response.Plans?.MainPlan?.PrivatePlan?.filter(obj => {
        return obj.ProductName?.toLowerCase().includes(planType)
    });
    if (!selectedPlan || selectedPlan?.length === 0) {
        selectedPlan = response.Plans?.MainPlan?.PrivatePlan?.filter(obj => {
            return obj.ProductName?.toLowerCase().includes('local')
        });
    }

    console.log('selectedPlan', selectedPlan)
    return selectedPlan && selectedPlan?.length !== 0 ? selectedPlan[0] : '';
}

export const getInternetSelectedPlanForBannerDoublePlay = (response, bannerData) => {
    let plan = '';
    if (bannerData?.indexOf('FIOSSPEED') !== -1) {
        plan = 'FIOSSPEED';
    } else if (bannerData?.indexOf('HSI') !== -1) {
        plan = "HSI";
    }
    const planIndex = bannerData?.indexOf(plan);
    const downloadSpeed = bannerData[planIndex + 1].slice(1);
    const uploadSpeed = bannerData[planIndex + 2].slice(1);
    const contract = bannerData[planIndex + 3] && bannerData[planIndex + 3] === 'MTM' ? 'MonthToMonth' : 'TwoYears';
    const ip = bannerData[planIndex + 4] && bannerData[planIndex + 4] === 'S' ? 'Static' : 'Dynamic';

    let neededObject = {};
    const planIdx = response.DataInfo.findIndex((plan) =>
        plan.UP_SPEED === uploadSpeed &&
        plan.DOWN_SPEED === downloadSpeed &&
        plan.IPType === ip &&
        plan.Contract === contract
    );
    if (planIdx > -1) {
        neededObject = response.DataInfo[planIdx];
    }
    return neededObject;
}

export const getInternetSelectedPlanForBannerTriplePlay = (response, bannerData) => {
    let plan = '';
    if (bannerData?.indexOf('FIOSSPEED') !== -1) {
        plan = 'FIOSSPEED';
    }
    const planIndex = bannerData?.indexOf(plan);
    const downloadSpeed = bannerData[planIndex + 1].slice(1);
    const uploadSpeed = bannerData[planIndex + 2].slice(1);
    const contract = bannerData[planIndex + 3] ? 'MonthToMonth' : 'TwoYears';
    const ip = bannerData[planIndex + 4] && bannerData[planIndex + 4] === 'S' ? 'Static' : 'Dynamic';

    let neededObject = {};
    const planIdx = response.BDVTP.findIndex((planObj) =>
        planObj.UPSPEED === uploadSpeed &&
        planObj.DOWNSPEED === downloadSpeed &&
        planObj.IPType === ip &&
        planObj.Contract === contract
    );
    if (planIdx > -1) {
        neededObject = response.BDVTP[planIdx];
    }
    return neededObject;
}

export const getInternetSelectedPlanForBannerVoiceDoublePlay = (response, bannerData) => {
    let plan = '';
    if (bannerData?.indexOf('FIOSSPEED') !== -1) {
        plan = 'FIOSSPEED';
    }
    const planIndex = bannerData?.indexOf(plan);
    const downloadSpeed = bannerData[planIndex + 1].slice(1);
    const uploadSpeed = bannerData[planIndex + 2].slice(1);
    const contract = bannerData[planIndex + 3] ? 'MonthToMonth' : 'TwoYears';
    const ip = bannerData[planIndex + 4] && bannerData[planIndex + 4] === 'S' ? 'Static' : 'Dynamic';
    let neededObject = {};
    const planIdx = response.DPBundleInfo.findIndex((planObj) =>
        (planObj.Contract === contract &&
            planObj.UP_SPEED === uploadSpeed &&
            planObj.DOWN_SPEED === downloadSpeed &&
            planObj.IPType === ip &&
            planObj.LineType === 'CPAK')
    );
    if (planIdx > -1) {
        neededObject = response.DPBundleInfo[planIdx];
    }
    return neededObject;
}

export const getTVSelectedPlan = (response, bannerData) => {
    // const planIndex = bannerData?.indexOf('FTV');
    // const viewtype = bannerData[planIndex + 1];
    // const product = bannerData[planIndex + 2];
    // const contract = bannerData[planIndex + 3] && bannerData[planIndex + 3] === 'MTM' ? 'MonthToMonth' : 'TwoYears';

    // const selectedPlan = response.FLEX.filter(obj => {
    //     return obj.TVTitle?.indexOf(viewtype) !== -1 &&
    //         obj.TVTitle?.indexOf(product) !== -1 &&
    //         obj.Contract === contract
    // });
    // return selectedPlan.length !== 0 ? selectedPlan[0] : '';
    return response?.TVInfo[0];
}

// TV section
export const getBannerTVData = (response, bannerData, tvViewType) => {
    const planIndex = bannerData?.indexOf('FTV');
    const applicableTVSrvc = tvServicesOffered.filter(e => bannerData?.indexOf(e) !== -1);
    const planType = applicableTVSrvc?.length > 0 ? bannerData[planIndex + 2]?.toLowerCase() : 'local';

    const selectedtvPlan = response.filter(tvObj => {
        return tvObj.PrdName?.toLowerCase()?.indexOf(planType) !== -1 &&
            tvObj.TVView === tvViewType;
    });
    return selectedtvPlan ? selectedtvPlan[0] : {};
}

// Phone Section
export const getBannerBDVPhoneData = (response, bannerData) => {
    return "Business Digital Voice";
}

export const getBannerSTDPhoneData = (response, bannerData) => {
    return "Standard Phone";
}
